var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMarker2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "factoryicon",
    className: "factoryicon",
    width: 20,
    height: 20,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3079 2.16357C14.0575 2.16741 10.9418 3.45708 8.64317 5.7499C6.34457 8.04272 5.05202 11.1509 5.04816 14.3937C5.04816 24.5545 15.5714 33.8949 17.308 33.8949C19.0446 33.8949 29.5678 24.5538 29.5678 14.3937C29.5639 11.1512 28.2711 8.04294 25.9728 5.7499C23.6744 3.45685 20.5587 2.16743 17.308 2.16357H17.3079ZM17.3079 8.77427C18.714 8.77427 20.0624 9.33146 21.0564 10.3234C22.0507 11.315 22.6093 12.6602 22.6093 14.0628C22.6093 15.4655 22.0507 16.8107 21.0564 17.8023C20.0624 18.7942 18.714 19.3514 17.3079 19.3514C15.9018 19.3514 14.5534 18.7942 13.5594 17.8023C12.5651 16.8107 12.0065 15.4655 12.0065 14.0628C12.0086 12.6607 12.5677 11.3167 13.5614 10.3254C14.5551 9.33411 15.9023 8.77631 17.3079 8.77427Z",
    fill: "#FFA500"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.0964,
    y: 8.65405,
    width: 12.4233,
    height: 12.2598,
    fill: "#FFA500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9554 18.1983V15.4891L15.8916 18.1983H15.4402V14.1345H13.634V18.1983H12.7309V14.1345H10.9248V18.1983H10.0217V24.5199H24.0194V15.4892L19.9554 18.1983ZM14.0852 22.7135H11.8275V20.4558H14.0852V22.7135ZM18.6007 22.7135H16.343V20.4558H18.6007V22.7135Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4717 10.52C19.4717 12.0182 14.8192 12.8628 14.0699 11.7505C13.8341 12.1926 13.209 12.3746 12.7245 12.1436C11.9209 11.7598 12.52 12.2462 11.6512 12.2462C10.9174 12.2462 10.539 11.4413 11.0582 10.9829C11.6464 10.4639 11.9964 11.0475 12.6474 10.6638C13.5844 10.1117 13.375 10.9728 14.326 10.2533C14.8882 9.82764 15.4088 10.1675 16.0118 9.8935C16.9598 9.46246 19.4717 8.73482 19.4717 10.52L19.4717 10.52Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43693 31.4866L5.33763 29.7681L5.61884 32.8301L3.43693 31.4866Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMarker2);
export default __webpack_public_path__ + "static/media/NewMarker2.a5c89bcf2eec4d1add677d2f370f68a0.svg";
export { ForwardRef as ReactComponent };